// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3GrMc","title":"Header_title__2Fw5x","side":"Header_side__3q_76"};